(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderTemplateComponentPictures',
	};

	var selected_images       = [],
		selected_hotel_images = [];
		// total_photos    = 0;
		// image = [],

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// google pictures
		Adzuki.Typeahead(
			'#fitbuildertemplatecomponentpictures-search',
			'/Searches/googleAutocomplete/',
			function select(item) {
				console.log(item.id);
				Adzuki.Ajax.get('/Searches/googlePlace/' + item.id)
				.then(function _getPlaceDetails(html) {
					$('.pictures').html(html);
				});

				$('#fitbuildertemplatecomponentpictures-search').prop('disabled', true);
				$('.reset-place').removeClass('hidden');
			},
			function template(item) {
				var html;

				html = item.name;
				return html;
			}
		);

		$('.pictures').on('click', '.google-image', function _selectPicture() {
			var image,
				src = $(this).data('src');

			if ($(this).hasClass('google-image-active')) {
				$(this).removeClass('google-image-active');

				image = selected_images.indexOf(src);

				if (image > -1) {
					selected_images.splice(image, 1);
				}

			} else {
				selected_images.push(src);

				$(this).addClass('google-image-active');
			}

			if (selected_images.length > 0) {
				$('.photo-count').html(selected_images.length + ' Selected');
			} else {
				$('.photo-count').html('');
			}

			$('#image_url').val(JSON.stringify(selected_images));
		});

		$('#reset-place-link').click(function _clearPlace(e) {
			e.preventDefault();

			$('#fitbuildertemplatecomponentpictures-search').val('');
			$('#fitbuildertemplatecomponentpictures-search').prop('disabled', false);
			$('.reset-place').addClass('hidden');
			$('.pictures').html('');
		});

		// hotel property pictures
		$('.fit-builder-hotel-image').click(function _selectHotel() {
			var image,
				src = $(this).data('src');

			if ($(this).hasClass('fit-builder-hotel-images-active')) {
				$(this).removeClass('fit-builder-hotel-images-active');

				image = selected_hotel_images.indexOf(src);

				if (image > -1) {
					selected_hotel_images.splice(image, 1);
				}
			} else {
				selected_hotel_images.push(src);

				$(this).addClass('fit-builder-hotel-images-active');
			}

			if (selected_hotel_images.length > 0) {
				$('.hotel-photo-count').html(selected_hotel_images.length);
			} else {
				$('.hotel-photo-count').html('0');
			}

			$('#hotel_image_url').val(JSON.stringify(selected_hotel_images));
		});

		// component image library
		$('.fb-library-check').click(function _checkUncheckAll(e) {
			var state = $(this).data('state'),
				$obj  = $(this);

			e.preventDefault();

			if (state === 'unchecked') {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', true);
				});

				$obj.data('state', 'checked');
			} else {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', false);
				});

				$obj.data('state', 'unchecked');
			}
		});

		$('.fb-add-from-library').click(function _addToComponent(e) {
			var selected                = [],
				fit_builder_template_id = $(this).data('fit-builder-template-id');

			e.preventDefault();

			$('.item-checkboxes').each(function _getSelected() {
				if ($(this).prop('checked') === true) {
					selected.push($(this).val());
				}
			});

			if (selected.length === 0) {
				Adzuki.StatusMessage("error", "Please select at least one picture to put on the component.");
			} else {
				Adzuki.Ajax.post('/FitBuilderTemplates/addPicturesFromLibrary/' + $('#fitbuilderlibrarysearch-component_id').val(), {selected: selected})
				.then(function success(content) {
					$('.fb-select-image-loader').css('visibility', 'visible');
					if (content.saved === 'true') {
						document.location = Adzuki.base_uri + '/FitBuilderTemplates/viewComponents/' + fit_builder_template_id;
					} else {
						$('.fb-select-image-loader').css('visibility', 'hidden');
						Adzuki.StatusMessage("error", "Unable to save pictures: " + content.saved + ".");
					}
				});
			}
		});

		$('.fb-existing-check').click(function _checkUncheckAll(e) {
			var state = $(this).data('state'),
				$obj  = $(this);

			e.preventDefault();

			if (state === 'unchecked') {
				$('.remove-item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', true);
				});

				$obj.data('state', 'checked');
			} else {
				$('.remove-item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', false);
				});

				$obj.data('state', 'unchecked');
			}
		});

		$('.fb-remove-from-component').click(function _removeFromComponent(e) {
			var selected                = [],
				fit_builder_template_id = $(this).data('fit-builder-template-id');

			e.preventDefault();

			$('.remove-item-checkboxes').each(function _getSelected() {
				if ($(this).prop('checked') === true) {
					selected.push($(this).val());
				}
			});

			if (selected.length === 0) {
				Adzuki.StatusMessage("error", "Please select at least one picture to remove from the component.");
			} else {
				Adzuki.Ajax.post('/FitBuilderTemplates/deletePicturesFromComponent/' + $('#fitbuilderremovepictures-component_id').val(), {selected: selected})
				.then(function success(content) {
					$('.fb-remove-image-loader').css('visibility', 'visible');

					if (content.saved === 'true') {
						document.location = Adzuki.base_uri + '/FitBuilderTemplates/viewComponents/' + fit_builder_template_id;
					} else {
						$('.fb-remove-image-loader').css('visibility', 'hidden');
						Adzuki.StatusMessage("error", "Unable to remove pictures: " + content.saved + ".");
					}
				});
			}
		});
	};
}(jQuery, window.Adzuki || {}));